import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  field: {
    width: '100%',
    '& > div': {
      width: '100%',
    }
  },
});
